<template>
    <var-overlay v-model:show="show">
        <div class="reset-password-body">
            <div :class="['login-body lie', IsMobile ? '' : 'pc-login-body']">
                <VarImage width="80" height="80" radius="50%" :src="require('@/assets/logo.png')" />
                <div class="content lie">
                    <var-input class="input" type="email" v-model="resetPasswordObj.Email"
                        :placeholder="$t('components.ResetPasswordComponent.email')">
                        <template #prepend-icon>
                            <var-icon name="youxiang" namespace="icon" />
                        </template>
                    </var-input>
                    <var-input class="input" type="text" v-model="resetPasswordObj.EmailCode"
                        :placeholder="$t('components.ResetPasswordComponent.mail_code')">
                        <template #prepend-icon>
                            <var-icon name="yanzhengyanzhengma" namespace="icon" />
                        </template>
                        <template #append-icon>
                            <VarButton v-if="TimeDown > 0" type="default">{{ TimeDown }}s
                            </VarButton>
                            <VarButton v-else @click="SendEmailCode(resetPasswordObj.Email)" type="primary">
                                {{ $t('components.ResetPasswordComponent.fasong') }}</VarButton>
                        </template>
                    </var-input>
                    <var-input class="input" type="password" v-model="resetPasswordObj.Password"
                        :placeholder="$t('components.ResetPasswordComponent.dlmm')">
                        <template #prepend-icon>
                            <var-icon name="mima" namespace="icon" />
                        </template>
                    </var-input>
                    <var-input class="input" type="password" v-model="resetPasswordObj.ResetPassword"
                        :placeholder="$t('components.ResetPasswordComponent.qrmm')">
                        <template #prepend-icon>
                            <var-icon name="zhongfumima" namespace="icon" />
                        </template>
                    </var-input>
                    <VarSpace style="width: 100%;" direction="row" justify="center">
                        <VarButton class="login-button" style="box-sizing: border-box; padding: 0px 20px;" type="primary" @click="ResetPassword">
                            {{ $t('components.ResetPasswordComponent.qrcz') }}
                        </VarButton>
                        <VarButton class="login-button" style="box-sizing: border-box; padding: 0px 20px;" @click="Close">
                            {{ $t('components.ResetPasswordComponent.quxiao') }}
                        </VarButton>
                    </VarSpace>

                </div>
            </div>
        </div>
    </var-overlay>
</template>

<script setup lang="ts">
import { useLocale } from '@/hooks/useLocale';
import { fetchResetPassword, InputRegister, InputResetPassword } from '@/typescript/Services/Api/AuthApi';
import { SendEmailCodeAsync } from '@/typescript/Services/Api/EmailApi';
import Global from '@/utils/Global';
import Tools from '@/utils/Tools';
import { inject, ref } from 'vue';
type InputType = "login" | "register" | "forgotPassword";
const local = useLocale();
const active = ref<InputType>("login");
const IsMobile = inject<boolean>("IsMobile");
const TimeDown = ref<number>(0);

const resetPasswordObj = ref<InputResetPassword & {
    ResetPassword: string
}>({
    Email: "",
    EmailCode: "",
    Password: "",
    ResetPassword: ""
});

const userName = ref('');
const password = ref('');
const show = ref(false);

/**
 * 显示登录框
 */
function Show() {
    userName.value = '';
    password.value = '';
    show.value = true;
}
/**
 * 关闭登录框
 */
function Close() {
    show.value = false;
}


/**
 * 显示登录框
 */
function ShowResetPassword() {
    active.value = "login";
    Show();
}

/**
 * 发送邮件验证码
 */
function SendEmailCode(email: string) {
    if (Tools.IsNull(email)) {
        Tools.AlertError(local.t('components.ResetPasswordComponent.qsr_email'));
        return;
    }
    SendEmailCodeAsync(email).then(resp => {
        if (resp.CheckIsOk()) {
            TimeDown.value = 60;
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.ResetPasswordComponent.yzmyfs'));
        }
    });
}

/**
 * 开始倒计时
 */
function StartTimeDown() {
    let timeDown = TimeDown.value;
    if (timeDown > 0) {
        TimeDown.value--;
        setTimeout(StartTimeDown, 1000);
    }
}



/**
 * 重置密码
 */
function ResetPassword() {
    fetchResetPassword(resetPasswordObj.value).then(resp => {
        if (resp.CheckIsOk()) {
            StartTimeDown();
            Tools.AlertSuccess(local.t('components.ResetPasswordComponent.czmmcg'));
        }
    });
}

defineExpose({
    ShowResetPassword
})

</script>

<style scoped lang="scss">
.pc-login-body {
    width: 60vw !important;
    border-radius: 10px;
}

.reset-password-body{
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.login-body {
    justify-content: center;
    align-items: center;
    background-color: var(--color-surface-container-highest);
    padding: 20px;
    width: 100%;
    height: 100%;

    .content {
        width: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
    }

    .input {
        width: 80%;
    }

    .login-button {
        margin-top: 20px;
        width: 80%;
    }

    .register-box {
        margin-top: 20px;
        justify-content: space-between;
        width: 50%;
    }
}
</style>